import axios from 'axios';
import Vue from 'vue';
export default {
  evNavBase: "https://evnav.appstack.me/",
  evNavKey: "U4VQU6Fv0AMaOlvfDNDLnibPn3CEKKZv",
  osrmBase: "https://maps.littlemonkey.co.nz/",
  osrmKey: "WKMZP4zuyX0nOXlN21X4DLUuezaQY6yv",

  async reverseGeocode(latlng) {
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Reverse Geocode",
        segmentation: {
          dealer: Vue.prototype.$dealer.default_settings.name,
        },
      },
    ]);
    const response = await axios.get(this.osrmBase + "reverse/?lat=" + latlng.lat + "&lon=" + latlng.lng + "&format=json&api_key=" + this.osrmKey);
    return response.data;
  },
  async getDirectTrip(trip) {
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "EVNav - Get Direct Route",
        segmentation: {
          dealer: Vue.prototype.$dealer.default_settings.name,
        },
      },
    ]);
    let src = { lat: trip[0][1].latitude || trip[0][1].Latitude, lng: trip[0][1].longitude || trip[0][1].Longitude };
    let dst = { lat: trip[trip.length - 1][1].latitude || trip[trip.length - 1][1].Latitude, lng: trip[trip.length - 1][1].longitude || trip[trip.length - 1][1].Longitude };
    let viaString = "";
    if (trip.length > 2) {
      let viaArray = []

      for (let i = 1; i < trip.length - 2; i++) {
        viaArray.push((trip[i][1].longitude || trip[i][1].Longitude) + "," + (trip[i][1].latitude || trip[i][1].Latitude));
      }
      if (viaArray.length > 0) {

        viaString = viaArray.join(";") + ";";
      }
    }

    const response = await axios.get(this.osrmBase + "driving/" + src.lng + "," + src.lat + ";" + viaString + dst.lng + "," + dst.lat + "?overview=full&geometries=geojson&api_key=" + this.osrmKey);
    return response.data;
  },
  async getDirectRoute(trip) {
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "EVNav - Get Direct Route",
        segmentation: {
          dealer: Vue.prototype.$dealer.default_settings.name,
        },
      },
    ]);
    let src = { lat: trip.fromAddress.Address.geometry.coordinates[1], lng: trip.fromAddress.Address.geometry.coordinates[0] };
    let dst = { lat: trip.toAddress.Address.geometry.coordinates[1], lng: trip.toAddress.Address.geometry.coordinates[0] };
    let viaString = "";
    if (trip.viaAddresses.length > 0) {
      let viaArray = []
      for (let v of trip.viaAddresses) {

        if (v.Address != null) {

          viaArray.push(v.Address.geometry.coordinates[0] + "," + v.Address.geometry.coordinates[1]);
        }
      }
      if (viaArray.length > 0) {

        viaString = viaArray.join(";") + ";";
      }
    }
    const response = await axios.get(this.osrmBase + "driving/" + src.lng + "," + src.lat + ";" + viaString + dst.lng + "," + dst.lat + "?overview=full&geometries=geojson&api_key=" + this.osrmKey);
    return response.data;
  },
  async getSimpleRoute(src, dst) {
    const response = await axios.get(this.osrmBase + "driving/" + src.lng + "," + src.lat + ";" + dst.lng + "," + dst.lat + "?overview=full&geometries=geojson&api_key=" + this.osrmKey);
    return response.data;
  },
  async getTable(home, points) {
    let src = { lat: parseFloat(home.Address.geometry.coordinates[1]).toFixed(3), lng: parseFloat(home.Address.geometry.coordinates[0]).toFixed(3) };
    let viaString = "";
    let destString = "";
    if (points.length > 0) {
      let viaArray = [];
      let index = 1;
      let destArray = [];
      for (let p of points) {
        viaArray.push(parseFloat(p.location[0]).toFixed(3) + "," + parseFloat(p.location[1]).toFixed(3));
        destArray.push(index);
        index++;
      }
      if (viaArray.length > 0) {
        viaString = viaArray.join(";");
        destString = destArray.join(";");
      }
    
    const response = await axios.get(this.osrmBase + "table/v1/driving/" + src.lng + "," + src.lat + ";" + viaString + "?sources=0&destinations="+destString+"&api_key=" + this.osrmKey);
    return response.data;
    }
  },
  async getChargersOnRoute(trip) {
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "EVNav - Chargers On Route",
        segmentation: {
          dealer: Vue.prototype.$dealer.default_settings.name,
        },
      },
    ]);
    let src = { lat: trip.fromAddress.Address.geometry.coordinates[1], lng: trip.fromAddress.Address.geometry.coordinates[0] };
    let dst = { lat: trip.toAddress.Address.geometry.coordinates[1], lng: trip.toAddress.Address.geometry.coordinates[0] };
    const response = await axios.post(this.evNavBase + "route/v1/evnav/" + src.lng + "," + src.lat + ";" + dst.lng + "," + dst.lat + "?api_key=" + this.evNavKey, { via: trip.flippedPath });
    return response.data;
  },
  async planRoute(trip, car, driver) {
    if (!car) {
      return [];
    }
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "EVNav - Plan Route",
        segmentation: {
          dealer: Vue.prototype.$dealer.default_settings.name,
        },
      },
    ]);
    let src = { lat: trip.fromAddress.Address.geometry.coordinates[1], lng: trip.fromAddress.Address.geometry.coordinates[0] };
    let dst = { lat: trip.toAddress.Address.geometry.coordinates[1], lng: trip.toAddress.Address.geometry.coordinates[0] };


    let viaArray = []
    if (trip.viaAddresses.length > 0) {
      for (let v of trip.viaAddresses) {
        if (v.Address != null) {
          viaArray.push(v.Address.geometry.coordinates[0] + "," + v.Address.geometry.coordinates[1]);
        }
      }
    }
    let params = this.createParams(car, driver);

    return await this.callEvNav(src, dst, viaArray, params);
  },
  createParams(car, driver) {
    let params = []
    params.push("m=" + (parseFloat(car.Weight || car.weight) + parseFloat(driver.extraWeight) + parseFloat(driver.passengers * 80)));
    params.push("crr=" + (car.CRR || car.crr));
    params.push("pce=" + (car.NewChainPerformanceTraction || car.chainPerformanceTraction));
    params.push("dc=" + (car.DragCoefficient || car.dragCoefficient));
    params.push("r=" + (car.NewRecoveryMax || car.recoveryMax));
    params.push("battery=" + (car.BatterySize || car.batterySize) * (driver.soh / 100));
    params.push("rating=" + (car.MaxDC || car.maxDC));
    params.push("AC_rating=" + (car.MaxAC || car.maxAC));
    if (car.PlugsList || car.plugsList) {
      params.push("plugs=" + (car.PlugsList || car.plugsList).replace(/,/g, "|"));
    }
    params.push("aa=" + (driver.aa / 100));
    params.push("sa=" + (driver.sa / 100));
    params.push("SOC_min=" + (driver.batteryMin / 100));
    params.push("SOC_max=" + (driver.batteryMax / 100));
    params.push("SOC_act=" + (driver.battery / 100));
    return params;
  },
  async chargerRadar(pos, car, driver) {
    console.log(pos);
    let params = this.createParams(car, driver);
    return axios.get(this.evNavBase + "radar/v1/evnav/" + pos.lng.toFixed(3) + "," + pos.lat.toFixed(3) + "?api_key=" + this.evNavKey + "&" + (params.length > 0 ? params.join("&") : ""));
  },
  async callEvNav(src, dst, via = [], params = []) {
    if (via.length > 0) {
      params.push("via=" + via.join(";"));
    }
    const response = await axios.get(this.evNavBase + "route/v1/evnav/" + src.lng.toFixed(3) + "," + src.lat.toFixed(3) + ";" + dst.lng.toFixed(3) + "," + dst.lat.toFixed(3) + "?points=true&api_key=" + this.evNavKey + "&" + (params.length > 0 ? params.join("&") : ""));
    return response.data;
  },
  async getEnergyPairs(pairs) {
    let src = { lng: pairs[0][0][0], lat: pairs[0][0][1] }
    let dst = { lng: pairs[0][1][0], lat: pairs[0][1][1] }
    const response = await axios.post(this.evNavBase + "energy/v1/evnav/" + src.lng + "," + src.lat + ";" + dst.lng + "," + dst.lat + "?api_key=" + this.evNavKey, { pairs: pairs });
    return response.data;
  }
}

